var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete-button",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.603,
    height: 17.976,
    viewBox: "0 0 14.603 17.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5856",
    "data-name": "Rectangle 5856",
    width: 14.603,
    height: 17.976,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21049",
    "data-name": "Group 21049",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9912",
    "data-name": "Path 9912",
    d: "M19.23,91.971h5.894c.492,0,.5,0,.477.475q-.215,4.678-.438,9.355a1.68,1.68,0,0,1-1.782,1.681q-4.175,0-8.35,0a1.683,1.683,0,0,1-1.776-1.687c-.152-3.13-.29-6.26-.446-9.39-.017-.338.076-.444.422-.442,2,.015,4,.007,6,.007m-2.267,5.054q0-1.755,0-3.509c0-.442-.21-.7-.56-.7s-.56.256-.56.7q0,3.509,0,7.019c0,.442.21.7.56.7s.56-.258.56-.7q0-1.755,0-3.509m1.686,0q0,1.755,0,3.509c0,.441.211.7.561.7s.56-.258.56-.7q0-3.509,0-7.019c0-.442-.211-.7-.561-.7s-.559.257-.559.7q0,1.755,0,3.509m3.929.007c0-1.2,0-2.41,0-3.615a.557.557,0,0,0-.551-.6.551.551,0,0,0-.564.587c-.005,2.41-.008,4.82.008,7.229a.677.677,0,0,0,.257.491.6.6,0,0,0,.541.023.767.767,0,0,0,.3-.535c.026-1.193.013-2.386.013-3.579",
    transform: "translate(-11.908 -85.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9913",
    "data-name": "Path 9913",
    d: "M4.494,2.251c0-.218,0-.4,0-.585A1.678,1.678,0,0,1,6.152.008C6.889,0,7.626,0,8.363.006a1.684,1.684,0,0,1,1.746,1.748c0,.15,0,.3,0,.48.133.006.246.016.358.016.9,0,1.8-.005,2.7,0A1.4,1.4,0,0,1,14.6,3.668c.006.3,0,.608,0,.912,0,.578-.179.76-.748.76H.8c-.638,0-.8-.165-.8-.814,0-.246,0-.491,0-.737A1.417,1.417,0,0,1,1.556,2.251q1.281,0,2.562,0Zm1.125-.023H8.984c0-.2.009-.37,0-.543a.545.545,0,0,0-.561-.551q-1.119-.016-2.238,0a.546.546,0,0,0-.562.55c-.011.173,0,.347,0,.544",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/Delete-button.823e75299a8659536e0c7381ddb346ac.svg";
export { ForwardRef as ReactComponent };